/*
 * stubbyz-customiser.js  (v4, overlay driver)
 * ===========================================
 * Thin driver connecting the Alpine root (window.__szMerch) to the ported
 * Printwear overlay engine in snippets/stubbyz-artwork-overlay.liquid.
 *
 * The overlay does all positioning/drag/resize/mockup on the MAIN product
 * image. This file just:
 *   - uploads the file to the Stubbyz upload worker
 *   - fires artwork:uploaded / artwork:reset / artwork:centre / artwork:sidechange
 *   - listens for artwork:position + artwork:mockupready and stores them on the
 *     Alpine root so submit() can send artUrl / mockupUrl / position.
 *
 * No Fabric.js. No separate preview canvas. No gallery-image mirroring here.
 */
(function () {
  function boot() {
    var root = window.__szMerch;
    if (!root) { return setTimeout(boot, 60); }
    var UPLOAD = (root.uploadWorker || "").replace(/\/$/, "");

    function currentSide() { return root.placement === "back" ? "back" : root.activeSide; }

    // ---- File input hooks (called from the Alpine template) ----
    root.triggerFile = function () { var el = document.querySelector('.sz-cust [x-ref="file"]'); if (el) el.click(); };
    root.onDrop = function (ev) { root.dragging = false; var f = ev.dataTransfer.files && ev.dataTransfer.files[0]; if (f) doUpload(f); };
    root.onFile = function (ev) { var f = ev.target.files && ev.target.files[0]; if (f) doUpload(f); };
    root.removeArt = function (side) {
      document.dispatchEvent(new CustomEvent("artwork:reset", { detail: { side: side } }));
      root.art[side] = null; root.art = Object.assign({}, root.art); if (root.saveState) root.saveState();
    };
    root.centreArt = function (side) {
      document.dispatchEvent(new CustomEvent("artwork:centre", { detail: { side: side } }));
    };

    function doUpload(file) {
      var side = currentSide();
      root.uploading = true; root.uploadError = "";
      var fd = new FormData(); fd.append("file", file);
      fetch(UPLOAD, { method: "POST", body: fd })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.secure_url) throw new Error(data.error || "Upload failed");
          var previewUrl = data.secure_url;
          if (/\.(ai|eps|svg)$/i.test(data.secure_url)) previewUrl = data.secure_url.replace(/\.[^/.]+$/, ".png");
          root.art[side] = { url: data.secure_url, previewUrl: previewUrl, mockupUrl: null, position: null };
          root.art = Object.assign({}, root.art);
          root.uploading = false;
          if (root.saveState) root.saveState();
          // Hand the preview URL to the overlay engine to place on the main image.
          document.dispatchEvent(new CustomEvent("artwork:uploaded", { detail: { side: side, url: previewUrl } }));
        })
        .catch(function (e) { root.uploading = false; root.uploadError = e.message || "Upload failed"; });
    }

    // ---- Listen back from the overlay engine ----
    document.addEventListener("artwork:position", function (e) {
      var side = e.detail.side;
      if (root.art[side]) { root.art[side].position = e.detail.pos; root.art = Object.assign({}, root.art); if (root.saveState) root.saveState(); }
    });

    document.addEventListener("artwork:mockupready", function (e) {
      var side = e.detail.side;
      if (!root.art[side] || !e.detail.dataUrl) return;
      // Upload the composited mockup for the order.
      fetch(e.detail.dataUrl).then(function (r) { return r.blob(); }).then(function (blob) {
        var fd = new FormData(); fd.append("file", new File([blob], "mockup-" + side + ".jpg", { type: "image/jpeg" }));
        return fetch(UPLOAD, { method: "POST", body: fd });
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data && data.secure_url && root.art[side]) { root.art[side].mockupUrl = data.secure_url; root.art = Object.assign({}, root.art); if (root.saveState) root.saveState(); }
      }).catch(function () {});
    });

    // ---- Tell the overlay which side is active when placement/tab changes ----
    var lastSide = currentSide();
    setInterval(function () {
      var s = currentSide();
      if (s !== lastSide) {
        lastSide = s;
        document.dispatchEvent(new CustomEvent("artwork:sidechange", { detail: { side: s } }));
      }
    }, 200);

    // ---- Colour change: request a fresh mockup once the new garment image loads ----
    document.addEventListener("sz:preview-colour", function () {
      // The theme swaps the main image; give it a moment, then re-render the mockup
      // for whichever side has art so the stored mockup matches the shown colour.
      setTimeout(function () {
        ["front","back"].forEach(function (side) {
          if (root.art[side]) document.dispatchEvent(new CustomEvent("artwork:rendermockup", { detail: { side: side } }));
        });
      }, 500);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
